import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Box } from '@mui/material';

import Tooltip from 'components/tooltip';
import { ReactComponent as BestBfcrIcon } from '../assets/best-bfcr-plan-icon.svg';
import { ReactComponent as BestBiologyIcon } from '../assets/best-biology-plan-icon.svg';
import { ReactComponent as BestEconomyIcon } from '../assets/best-economy-plan-icon.svg';
import { ReactComponent as BestEnvironmentIcon } from '../assets/best-environment-plan-icon.svg';
import { ReactComponent as LowestCostOfGrowthIcon } from '../assets/lowest-cost-of-growth-plan-icon.svg';
import { VisibleScenarioAwardKey } from 'views/bluviu-nutrition/features/scenarios-v2/utils/compare-result-utils';

const awardIconConfig: Record<VisibleScenarioAwardKey, { title: React.ReactNode; icon: React.ReactNode }> = {
  lowestCO2: {
    title: <FormattedMessage id="bluViuNutrition.viewScenarioResultGt2.icons.lowestCo2Title" />,
    icon: <BestEnvironmentIcon />,
  },
  lowestFeedPrice: {
    title: <FormattedMessage id="bluViuNutrition.viewScenarioResultGt2.icons.mostEconomicalTitle" />,
    icon: <BestEconomyIcon />,
  },
  fastestGrowth: {
    title: <FormattedMessage id="bluViuNutrition.viewScenarioResultGt2.icons.bestBioTitle" />,
    icon: <BestBiologyIcon />,
  },
  bestBFcr: {
    title: <FormattedMessage id="bluViuNutrition.viewScenarioResultGt2.icons.bestBFcrTitle" />,
    icon: <BestBfcrIcon />,
  },
  lowestCostOfGrowth: {
    title: <FormattedMessage id="bluViuNutrition.viewScenarioResultGt2.icons.lowestCostOfGrowthTitle" />,
    icon: <LowestCostOfGrowthIcon />,
  },
};

type Props = {
  visibleAwardKeys: VisibleScenarioAwardKey[];
  showPlaceholder?: boolean;
};

const ScenarioAwardIcons: React.FC<Props> = ({ visibleAwardKeys, showPlaceholder = false }) => {
  if (visibleAwardKeys.length === 0 && showPlaceholder) {
    return (
      <Box component="span" display="flex" visibility="hidden" aria-hidden>
        {awardIconConfig.lowestCO2.icon}
      </Box>
    );
  }

  return (
    <Box display="flex" flexDirection="row" flexWrap="wrap" justifyContent="center" alignItems="center" gap={2}>
      {visibleAwardKeys.map((awardKey) => {
        const { title, icon } = awardIconConfig[awardKey];

        return (
          <Tooltip key={awardKey} title={title}>
            <Box component="span" display="flex" flexShrink={0}>
              {icon}
            </Box>
          </Tooltip>
        );
      })}
    </Box>
  );
};

export default ScenarioAwardIcons;
